module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "ys-dialog ys-album-report-dialog",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "left-pane",
    attrs: {
      "xs5": "",
      "px-3": "",
      "py-4": ""
    }
  }, [_c('h3', [_vm._v("Report Content")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "mandatory": false
    },
    model: {
      value: (_vm.active_violation),
      callback: function($$v) {
        _vm.active_violation = $$v
      },
      expression: "active_violation"
    }
  }, _vm._l((_vm.violations), function(v) {
    return _c('v-radio', {
      key: v.value,
      attrs: {
        "label": v.label,
        "value": v.value
      },
      on: {
        "change": function($event) {
          _vm.reason = ''
        }
      }
    })
  })), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', [_vm._v("\n      Yousound reviews all reports to verify if users are in violation of our\n      "), _c('b', [_vm._v("Terms of Service")]), _vm._v(". Accounts falsely reporting content may have\n      their accounts terminated.\n    ")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "right-pane",
    attrs: {
      "xs7": ""
    }
  }, [(_vm.active_violation != 'infringe') ? _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('v-flex', {
    attrs: {
      "x12": "",
      "pa-3": ""
    }
  }, [_c('h3', [_vm._v("Specify the violation")]), _vm._v(" "), _c('p', [_vm._v("\n            Yousound reviews all reports to verify if users are in violation\n            of our "), _c('b', [_vm._v("Terms of Service")]), _vm._v("."), _c('br'), _vm._v("Accounts falsely reporting\n            content may have their accounts terminated.\n          ")]), _vm._v(" "), (_vm.violation.options.length) ? _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.violation.options,
      "data-vv-name": "reason",
      "error-messages": _vm.errors.collect('reason'),
      "label": "Choose one",
      "single-line": ""
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:500'),
      expression: "'required|max:500'"
    }],
    staticClass: "mt-3",
    attrs: {
      "label": "Provide additional details",
      "data-vv-name": "description",
      "error-messages": _vm.errors.collect('description'),
      "counter": 500,
      "max": "500",
      "full-width": "",
      "multi-line": "",
      "single-line": ""
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right-pane__footer"
  }, [_c('v-flex', {
    attrs: {
      "px-2": ""
    }
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_vm._v("CANCEL")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "flat": ""
    }
  }, [_vm._v("NEXT")])], 1)], 1)]) : _c('div', [_c('v-flex', {
    attrs: {
      "x12": "",
      "pa-3": ""
    }
  }, [_c('h3', [_vm._v("Specify the violation")]), _vm._v(" "), _c('p', [_vm._v("\n          Yousound reviews all reports to verify if users are in violation of\n          our "), _c('b', [_vm._v("Terms of Service")]), _vm._v("."), _c('br'), _vm._v("Accounts falsely reporting content\n          may have their accounts terminated.\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3 px-3",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    }
  }, [_vm._v("File Copyright Claim")])], 1)], 1)]), _vm._v(" "), (_vm.show_confirm_view) ? _c('div', {
    staticClass: "confirm-view"
  }, [_c('h3', [_vm._v("Your Report Has Been Filed")]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Issue:")]), _c('span', [_vm._v(_vm._s(_vm.violation.label))])]), _vm._v(" "), _c('p', [_vm._v("\n      If we find this content to be in violation of our\n      "), _c('b', [_vm._v("Term of Services")]), _vm._v(", we will remove it.\n    ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    on: {
      "click": function($event) {
        _vm.closeConfirmView()
      }
    }
  }, [_vm._v("Close")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45673994","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/album_report_dialog.vue
// module id = 1707
// module chunks = 180